import { render, staticRenderFns } from "./eprolo.vue?vue&type=template&id=48d8c5dc&scoped=true"
import script from "./eprolo.vue?vue&type=script&lang=js"
export * from "./eprolo.vue?vue&type=script&lang=js"
import style0 from "./eprolo.vue?vue&type=style&index=0&id=48d8c5dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d8c5dc",
  null
  
)

export default component.exports